// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6a203734","703":"e46e4328","787":"c209567c"}[chunkId] + ".chunk.js";
};